<template>
  <tr :class="{'is-marked': marked}">
    <td>
      <a
        :href="fulcrumAppUrl"
        title="Dashboard"
      >{{ label ? label : 'N/A' }}</a>
      <div v-if="policyUpdate && name" class="note">{{ name }}</div>
    </td>

    <td class="text-end">
      {{ lastSync ? h$.formatDate.full(lastSync, true) : 'N/A'}}
    </td>

    <td class="table-row-actions">
      <RowAction
        :href="fulcrumAppUrl"
        action="read"
      />

      <RowAction
        v-if="policyUpdate"
        :href="fulcrumAppUrl + '/edit'"
        action="update"
      />
    </td>
  </tr>
</template>

<script>
import Row from "../shared/grid/row";
import RowAction from "../shared/grid/row_action";
import DetailsButton from "../shared/grid/details_button";

import helpers from "../../helpers.js";

export default {
  extends: Row,

  components: {
    RowAction,
    DetailsButton
  },

  props: {
    index: Number,
    id: String,
    formId: String,
    label: String,
    name: String,
    clientCompany: Object,
    lastSync: String
  },

  setup () {
    return {
      h$: helpers
    }
  },

  computed: {
    fulcrumAppUrl: function () {
      return "/project_dashboards/" + this.id
    }
  }
}
</script>
